import { Stack, useTheme } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { reminderRowAnchorId } from "web_myplann/NotificationCenter/Utils/reminderScrollParam";
import { DetailCard } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailCard";
import { PinInlineAction } from "web_myplann/Portfolio/Components/Redesign/Detail/PinInlineAction";
import { ReminderFlatEmptyRow } from "web_myplann/Reminders/Components/ReminderFlatEmptyRow";
import { ReminderFlatRow } from "web_myplann/Reminders/Components/ReminderFlatRow";
import { ReminderListRowSkeleton } from "web_myplann/Reminders/Components/ReminderListRowSkeleton";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";

type Props = {
	reminders: Reminder[];
	isLoading: boolean;
	highlightedId: string | null;
	onAdd: () => void;
	onTap: (reminder: Reminder) => void;
};

export const RemindersFlatList = ({
	reminders,
	isLoading,
	highlightedId,
	onAdd,
	onTap,
}: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<DetailCard label={t(Resources.Reminders.Section.title)}>
			{isLoading ? (
				<Stack
					gap={theme.spacingTokens.lg}
					px={theme.spacingTokens.lg}
					py={theme.spacingTokens.md}
				>
					<ReminderListRowSkeleton />
				</Stack>
			) : (
				<>
					{reminders.length === 0 && <ReminderFlatEmptyRow />}
					{reminders.map((reminder) => (
						<ReminderFlatRow
							key={reminder.id}
							id={reminderRowAnchorId(reminder.id)}
							reminder={reminder}
							highlighted={reminder.id === highlightedId}
							onTap={() => onTap(reminder)}
						/>
					))}
					<PinInlineAction
						label={t(Resources.Reminders.Section.addButton)}
						onClick={onAdd}
					/>
				</>
			)}
		</DetailCard>
	);
};
